(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6512],{

/***/ 92089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42670);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48089);
/* harmony import */ var _messages__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25655);







var FormErrorMessage = function(param) {
    var _errors = param.errors, errors = _errors === void 0 ? [] : _errors;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: errors.map(function(error) {
            var message = _messages__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z[error.id];
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Error */ .j, {
                "data-testid": error.id,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, message), {
                    values: error.values
                }))
            }, error.id);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormErrorMessage);


/***/ }),

/***/ 25655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49177);

var messages = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessages */ .vU)({
    required: {
        id: "validation.required"
    },
    minLength: {
        id: "validation.min"
    },
    maxLength: {
        id: "validation.max"
    },
    invalid: {
        id: "validation.invalid"
    },
    fillField: {
        id: "validation.fill-field"
    },
    validEmail: {
        id: "login.valid-email"
    },
    pleaseEmail: {
        id: "subscription.please-enter-your-email"
    },
    pleaseEnterPassword: {
        id: "subscription.please-enter-password"
    },
    passwordLength: {
        id: "global.password-length"
    },
    subscriptionRepeatPassword: {
        id: "subscription.repeat-password"
    },
    legalTerms: {
        id: "legal.terms-validation"
    },
    passwordDifferent: {
        id: "login.password-different"
    },
    paxNames: {
        id: "error.room-names"
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (messages);


/***/ }),

/***/ 18499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Link; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/ds/src/index.ts + 105 modules
var src = __webpack_require__(55349);
// EXTERNAL MODULE: ../../packages/react-context/src/index.tsx + 11 modules
var react_context_src = __webpack_require__(67048);
// EXTERNAL MODULE: ../../packages/uikit/src/index.ts + 76 modules
var uikit_src = __webpack_require__(57923);
// EXTERNAL MODULE: ./client/icons/ChevronRight.js
var ChevronRight = __webpack_require__(72455);
// EXTERNAL MODULE: ./client/icons/createSvgIcon.tsx + 1 modules
var createSvgIcon = __webpack_require__(88121);
;// CONCATENATED MODULE: ./client/icons/Map.js



/* harmony default export */ var Map = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M23.607.24C23.245 0 22.884 0 22.523.12L16.74 2.41 7.467 0h-.601L.842 2.409C.241 2.649 0 3.13 0 3.613v16.862c0 .361.24.723.482.964.24.12.482.24.722.24.12 0 .362 0 .482-.12l5.661-2.288 9.274 2.288h.24c.121 0 .242 0 .362-.12l6.022-2.41c.482-.24.723-.601.723-1.083V1.204c.12-.36-.12-.722-.361-.963zM2.409 4.457l3.613-1.445v14.212L2.41 18.67V4.456zM8.43 2.77l7.227 1.807v14.332L8.43 17.103V2.77zM21.68 17.223l-3.614 1.446V4.456l3.614-1.445v14.212z"
}), "Map"));

// EXTERNAL MODULE: ./client/utils.js + 2 modules
var utils = __webpack_require__(30796);
// EXTERNAL MODULE: ./lib/utils/page.ts
var page = __webpack_require__(96011);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(94449);
// EXTERNAL MODULE: ./src/constants/routes.js
var routes = __webpack_require__(54166);
// EXTERNAL MODULE: ./src/effects/Search/selectors.js
var selectors = __webpack_require__(22671);
// EXTERNAL MODULE: ./src/hooks/useKafkaEvent/index.ts
var useKafkaEvent = __webpack_require__(96128);
// EXTERNAL MODULE: ./src/hooks/useKafkaEvent/constants.ts
var constants = __webpack_require__(18935);
// EXTERNAL MODULE: ./src/hooks/usePage/index.ts
var usePage = __webpack_require__(73250);
;// CONCATENATED MODULE: ./client/components/Map/Link/index.tsx


















var MapLink = function(param) {
    var propertyId = param.propertyId, _variant = param.variant, variant = _variant === void 0 ? "link" : _variant;
    var getDestinationUrl = function getDestinationUrl(query) {
        if (propertyId) {
            return (0,page/* buildLocation */.oN)({
                page: routes/* routes.map.page */._.map.page,
                path: {
                    country: searchParams.country,
                    type: searchParams.type,
                    slug: searchParams.slug
                },
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                    highlightedProperty: "".concat(propertyId)
                })
            });
        }
        return (0,page/* buildLocation */.oN)({
            page: routes/* routes.map.page */._.map.page,
            path: searchParams,
            query: query
        });
    };
    var goToMap = function goToMap() {
        var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var destinationUrl = getDestinationUrl((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
            internal_navigation: "true"
        }));
        (0,utils/* scrollToTop */.k3)();
        router.push(destinationUrl.href, destinationUrl.as);
    };
    var i18n = (0,react_context_src/* useS4LContext */.ms)().i18n;
    var router = (0,next_router.useRouter)();
    var pageId = (0,usePage/* usePage */.q)().pageId;
    var searchParams = (0,es/* useSelector */.v9)(selectors/* getSearch */.on);
    var sendEvent = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: pageId,
        eventName: "show_on_map"
    }).sendEvent;
    var query = (0,next_router.useRouter)().query;
    var handleClick = function() {
        sendEvent({
            section: constants/* SECTIONS.HEADER */.SA.HEADER
        });
        goToMap(query);
    };
    if (variant === "filter-button") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Button */.zx, {
            variant: "outlined-rounded",
            onClick: handleClick,
            leadingIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Map, {
                size: 16
            }),
            size: "small",
            fullWidth: true,
            children: i18n.formatMessage({
                id: "global.map"
            })
        });
    }
    if (variant === "map-button") {
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: handleClick,
            style: {
                height: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src/* MapSelector */.RY, {})
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Button */.zx, {
        variant: "text-flat",
        onClick: handleClick,
        size: "small",
        trailingIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
            size: 16
        }),
        children: i18n.formatMessage({
            id: "global.show-on-map"
        })
    });
};
/* harmony default export */ var Link = (MapLink);


/***/ }),

/***/ 79089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ fetchLocationSuccessAction; }
/* harmony export */ });
/* unused harmony export fetchLocationFailedAction */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57534);

var fetchLocationSuccessAction = function(payload) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .FETCH_LOCATION_SUCCESS */ .xQ,
        payload: payload
    };
};
var fetchLocationFailedAction = function(payload) {
    return {
        type: FETCH_LOCATION_FAILED,
        payload: payload
    };
};


/***/ }),

/***/ 65427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ updateQueryStringHighlighted; },
/* harmony export */   "w": function() { return /* binding */ updateQueryStringFilters; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34126);




function updateQueryStringFilters(filters, base) {
    var ref;
    var currentQueryString = base || (window === null || window === void 0 ? void 0 : window.location.search) || "";
    var currentParams = query_string__WEBPACK_IMPORTED_MODULE_0__.parse(currentQueryString);
    // Remove from query unwanted previous filters
    var stars = currentParams.stars, family = currentParams.family, orderBy = currentParams.orderBy, facilities = currentParams.facilities, accommodationTypes = currentParams.accommodationTypes, ratings = currentParams.ratings, maxPrice = currentParams.maxPrice, minPrice = currentParams.minPrice, page = currentParams.page, highlightedProperty = currentParams.highlightedProperty, cityQuery = currentParams.city, termQuery = currentParams.term, filtersObjQuery = currentParams.filters, lonQuery = currentParams.longitude, latQuery = currentParams.latitude, slugQuery = currentParams.slug, typeQuery = currentParams.type, restOldFilters = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(currentParams, [
        "stars",
        "family",
        "orderBy",
        "facilities",
        "accommodationTypes",
        "ratings",
        "maxPrice",
        "minPrice",
        "page",
        "highlightedProperty",
        "city",
        "term",
        "filters",
        "longitude",
        "latitude",
        "slug",
        "type"
    ]);
    // Remove from query unwanted new filters
    var city = filters.city, longitude = filters.longitude, latitude = filters.latitude, slug = filters.slug, type = filters.type, pageNew = filters.page, orderByNew = filters.orderBy, filtersObj = filters.filters, restNewFilters = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(filters, [
        "city",
        "longitude",
        "latitude",
        "slug",
        "type",
        "page",
        "orderBy",
        "filters"
    ]);
    // Stringify children array: [[1,2], [3,4]] => '1,2!3,4' (! separated rooms, comma separated ages in each room)
    var children = (ref = filters.children) === null || ref === void 0 ? void 0 : ref.map(function(child) {
        return child.join(",");
    }).join("!");
    var coordinates = JSON.stringify(restNewFilters.coordinates);
    var boxShape = JSON.stringify(restNewFilters.boxShape);
    return query_string__WEBPACK_IMPORTED_MODULE_0__.stringify((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, restOldFilters, restNewFilters), {
        children: children,
        coordinates: coordinates,
        boxShape: boxShape
    }), {
        arrayFormat: "comma",
        skipEmptyString: true,
        skipNull: true
    });
}
function updateQueryStringHighlighted(param) {
    var highlightedProperty = param.highlightedProperty, aid = param.aid, source = param.source, total = param.total, subtotal = param.subtotal, taxes = param.taxes, // eslint-disable-next-line camelcase
    internal_navigation = param.internal_navigation, // eslint-disable-next-line camelcase
    feature_flag = param.feature_flag;
    return query_string__WEBPACK_IMPORTED_MODULE_0__.stringify(// eslint-disable-next-line camelcase
    {
        highlightedProperty: highlightedProperty,
        aid: aid,
        source: source,
        total: total,
        subtotal: subtotal,
        taxes: taxes,
        internal_navigation: internal_navigation,
        feature_flag: feature_flag
    }, {
        arrayFormat: "comma",
        skipEmptyString: true,
        skipNull: true
    });
}


/***/ }),

/***/ 39003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Atom_Select; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./client/icons/Done.js
var Done = __webpack_require__(47012);
// EXTERNAL MODULE: ./src/comps/Atom/Select/styles.module.css
var styles_module = __webpack_require__(67780);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(12524);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/comps/Atom/Drowpdown/index.tsx + 2 modules
var Drowpdown = __webpack_require__(38061);
// EXTERNAL MODULE: ./src/comps/Atom/Text/index.tsx
var Text = __webpack_require__(63586);
// EXTERNAL MODULE: ./client/icons/createSvgIcon.tsx + 1 modules
var createSvgIcon = __webpack_require__(88121);
;// CONCATENATED MODULE: ./client/icons/ArrowUpDown.tsx



/* harmony default export */ var ArrowUpDown = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M19.9546 9.9251C19.9546 10.1251 19.8546 10.4251 19.7546 10.6251C19.3546 11.0251 18.7546 11.1251 18.3546 10.7251L11.9546 5.2251L5.65464 10.7251C5.25464 11.1251 4.55464 11.0251 4.25464 10.6251C3.85464 10.2251 3.95464 9.5251 4.35464 9.2251L11.3546 3.2251C11.7546 2.9251 12.2546 2.9251 12.6546 3.2251L19.6546 9.2251C19.8546 9.3251 19.9546 9.6251 19.9546 9.9251Z"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M19.9546 15.0544C19.9546 14.8544 19.8546 14.5544 19.7546 14.3544C19.3546 13.9544 18.7546 13.8544 18.3546 14.2544L11.9546 19.7544L5.65464 14.2544C5.25464 13.8544 4.55464 13.9544 4.25464 14.3544C3.85464 14.7544 3.95464 15.4544 4.35464 15.7544L11.3546 21.7544C11.7546 22.0544 12.2546 22.0544 12.6546 21.7544L19.6546 15.7544C19.8546 15.6544 19.9546 15.3544 19.9546 15.0544Z"
        })
    ]
}), "ArrowUpDown"));

// EXTERNAL MODULE: ./client/icons/ArrowDown.js
var ArrowDown = __webpack_require__(53589);
;// CONCATENATED MODULE: ./src/comps/Atom/Select/index.tsx










function Select(param) {
    var label = param.label, triggerVariant = param.triggerVariant, onChange = param.onChange, options = param.options, defaultValue = param.defaultValue, _align = param.align, align = _align === void 0 ? "center" : _align;
    var handleSelectOrder = function handleSelectOrder(newOrder) {
        setCurrentOrder(newOrder);
        onChange(newOrder);
        setIsOpen(false);
    };
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(defaultValue !== null && defaultValue !== void 0 ? defaultValue : options[0]), currentOrder = ref1[0], setCurrentOrder = ref1[1];
    var _obj;
    var trigger = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "trigger",
        className: classnames_default()((styles_module_default()).trigger, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (styles_module_default()).triggerSort, triggerVariant === "sort"), (0,_define_property/* default */.Z)(_obj, (styles_module_default()).triggerSelect, triggerVariant === "select"), (0,_define_property/* default */.Z)(_obj, (styles_module_default()).active, isOpen), _obj)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                variant: "captionL",
                ellipsis: true,
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                        as: "span",
                        children: [
                            label,
                            " \xa0"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        as: "span",
                        weight: "weight3",
                        children: currentOrder.value
                    })
                ]
            }),
            triggerVariant === "sort" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUpDown, {
                size: 16
            }),
            triggerVariant === "select" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                size: 16
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Drowpdown/* default */.Z, {
        show: isOpen,
        onShowChange: setIsOpen,
        align: align,
        showClose: false,
        trigger: trigger,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: (styles_module_default()).list,
            children: options.map(function(order) {
                var key = order.key, value = order.value;
                var isCurrentOrder = key === currentOrder.key;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        className: classnames_default()((styles_module_default()).option, (0,_define_property/* default */.Z)({}, (styles_module_default()).selected, isCurrentOrder)),
                        onClick: function() {
                            return handleSelectOrder(order);
                        },
                        role: "menuitem",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                variant: "textBodyL",
                                weight: isCurrentOrder ? "weight3" : "weight2",
                                children: value
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Done["default"], {
                                size: 24
                            })
                        ]
                    })
                }, "".concat(key));
            })
        })
    });
}
/* harmony default export */ var Atom_Select = (Select);


/***/ }),

/***/ 50746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ comps_BuilderModal; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(96204);
// EXTERNAL MODULE: ./client/components/Modal/index.js
var Modal = __webpack_require__(38997);
// EXTERNAL MODULE: ./client/components/Modal/constants.js
var constants = __webpack_require__(61673);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(94449);
// EXTERNAL MODULE: ./src/constants/subscriptionSources.js
var subscriptionSources = __webpack_require__(4077);
// EXTERNAL MODULE: ./src/effects/SubscriptionStatus/actions.js
var actions = __webpack_require__(92186);
// EXTERNAL MODULE: ./src/effects/SubscriptionStatus/constants.js
var SubscriptionStatus_constants = __webpack_require__(26111);
// EXTERNAL MODULE: ./src/effects/SubscriptionStatus/selectors.js
var selectors = __webpack_require__(72926);
// EXTERNAL MODULE: ./src/hooks/useMarket.ts
var useMarket = __webpack_require__(59806);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ./client/helpers/Form/index.ts + 1 modules
var Form = __webpack_require__(5766);
// EXTERNAL MODULE: ../../packages/ds/src/index.ts + 105 modules
var src = __webpack_require__(55349);
// EXTERNAL MODULE: ../../packages/icons/lib/IconArrowRight.tsx
var IconArrowRight = __webpack_require__(75300);
// EXTERNAL MODULE: ./src/comps/Molecules/Subscription/SubscriptionModal/styles.module.css
var styles_module = __webpack_require__(34523);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./client/components/MessageTerms/index.tsx
var MessageTerms = __webpack_require__(68984);
// EXTERNAL MODULE: ./src/comps/Atom/Inputs/Input/Input.tsx
var Input = __webpack_require__(69475);
// EXTERNAL MODULE: ./client/components/FormErrorMessage/messages.ts
var messages = __webpack_require__(25655);
// EXTERNAL MODULE: ./src/comps/Image/index.tsx
var Image = __webpack_require__(55880);
// EXTERNAL MODULE: ./src/constants/environment.js
var environment = __webpack_require__(65003);
;// CONCATENATED MODULE: ./src/comps/Molecules/Subscription/SubscriptionModal/index.tsx













var BLACK_FRIDAY_25_IMAGE_URL = "/black-friday-modal/black-friday-2-2025.png";
function SubscriptionModal(props) {
    var status = props.status, onSubscribe = props.onSubscribe;
    var ref = (0,react.useState)([]), errors = ref[0], setErrors = ref[1];
    var ref1 = (0,react.useState)(""), email = ref1[0], setEmail = ref1[1];
    var intl = (0,useIntl/* default */.Z)();
    var ref2 = (0,react.useState)(false), formSubmitted = ref2[0], setFormSubmitted = ref2[1];
    if (status === SubscriptionStatus_constants/* SUBSCRIBED */.Wx) {
        return null;
    }
    var handleChangeEmail = function(newEmail) {
        setEmail(newEmail);
    };
    var handleSubmit = function(e) {
        e.preventDefault();
        setFormSubmitted(true);
        if ((0,Form/* validateEmail */.oH)(email)) {
            setErrors([
                {
                    id: "validEmail"
                }
            ]);
            return;
        }
        setErrors([]);
        onSubscribe(email);
    };
    if (status === SubscriptionStatus_constants/* UNSUBSCRIBED */.$y) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "".concat(environment/* PATH_IMAGES_CDN */.VZ).concat(BLACK_FRIDAY_25_IMAGE_URL),
                    alt: "Black Friday 2025",
                    style: {
                        objectFit: "cover",
                        width: "100%",
                        height: "100%"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).subscriptionModalBase,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            className: (styles_module_default()).subscriptionModalTitle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "promo.black-friday-25-popuphome-title"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (styles_module_default()).subscriptionModalSubTitle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "promo.black-friday-25-popuphome-subtitle"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            className: (styles_module_default()).subscriptionForm,
                            "data-testid": "subscription-form",
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    errors: errors.map(function(error) {
                                        var message = messages/* default */.Z[error.id];
                                        return intl.formatMessage(message);
                                    }),
                                    label: intl.formatMessage({
                                        id: "global.email"
                                    }),
                                    value: email,
                                    onChange: handleChangeEmail,
                                    disabled: formSubmitted && errors.length === 0
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Button */.zx, {
                                    disabled: formSubmitted && errors.length === 0,
                                    variant: "filled-rounded",
                                    trailingIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowRight/* IconArrowRight */.E, {}),
                                    size: "small",
                                    fullWidth: true,
                                    type: "submit",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "global.modal-home-subscription-cta"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).termsContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageTerms/* default */.Z, {
                                isEmail: true
                            })
                        })
                    ]
                })
            ]
        });
    }
    return null;
}

// EXTERNAL MODULE: ../../node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(21805);
// EXTERNAL MODULE: ./src/constants/cookies.ts
var cookies = __webpack_require__(42290);
;// CONCATENATED MODULE: ./src/comps/BuilderModal/utils.ts


function setSubscriptionModalClosedCookie() {
    js_cookie/* default.set */.Z.set(cookies/* COOKIE_SUBSCRIPTION_MODAL_CLOSED */.B_, "true", {
        expires: cookies/* COOKIE_EXP_7D */.ck
    });
}
function getSubscriptionModalClosedCookie() {
    return Boolean(js_cookie/* default.get */.Z.get(cookies/* COOKIE_SUBSCRIPTION_MODAL_CLOSED */.B_));
}

// EXTERNAL MODULE: ./src/hooks/useBusiness.ts
var useBusiness = __webpack_require__(16153);
// EXTERNAL MODULE: ./src/constants/affiliates.ts
var affiliates = __webpack_require__(1620);
;// CONCATENATED MODULE: ./src/comps/BuilderModal/index.tsx

















var BuilderModal = function(param) {
    var _isSubscriptionModalActive = param.isSubscriptionModalActive, isSubscriptionModalActive = _isSubscriptionModalActive === void 0 ? false : _isSubscriptionModalActive;
    var ref = (0,useMarket/* useMarket */.A)(), locale = ref.locale, market = ref.market, language = ref.language, feedbackMessageType = ref.feedbackMessageType;
    var affiliate = (0,useBusiness/* useBusiness */.i)().affiliate;
    var ref1 = (0,react.useState)(false), showBuilderModal = ref1[0], setShowBuilderModal = ref1[1];
    var ref2 = (0,react.useState)(false), showSubscriptionModal = ref2[0], setShowSubscriptionModal = ref2[1];
    var ref3 = (0,react.useState)(), content = ref3[0], setContent = ref3[1];
    var allMarkets = "all";
    var modalId = "en-modal";
    var dispatch = (0,es/* useDispatch */.I0)();
    var subscriptionStatus = (0,es/* useSelector */.v9)(selectors/* getSubscriptionStatus */.ku);
    var handleSubscribe = function(emailToSubscribe) {
        setSubscriptionModalClosedCookie();
        dispatch((0,actions/* subscribeRequestAction */.k2)({
            hash: emailToSubscribe,
            language: language,
            market: market,
            feedbackMessageType: feedbackMessageType,
            source: subscriptionSources/* SUBSCRIPTION_MODAL_HOME_PAGE */.lI
        }));
    };
    var handleCloseSubscriptionModal = function() {
        setShowSubscriptionModal(false);
        setSubscriptionModalClosedCookie();
    };
    var isAffiliateEmail = affiliate && affiliates/* AFFILIATES_EMAIL.includes */.h4.includes(affiliate);
    var router = (0,next_router.useRouter)();
    var _query = router.query, builderModal = _query.builder_modal;
    var getModal = (0,react.useCallback)(function(marketToSearch) {
        return builder_react_es5/* builder.get */.fl.get(modalId, {
            url: window.location.pathname,
            userAttributes: {
                locale: locale
            },
            includeUnpublished: builderModal === "draft",
            options: {
                locale: locale
            },
            query: {
                "data.markets": {
                    $elemMatch: {
                        market: {
                            $regex: "^".concat(marketToSearch, "$"),
                            $options: "i"
                        }
                    }
                }
            }
        }).promise();
    }, [
        locale,
        builderModal
    ]);
    (0,react.useEffect)(function() {
        getModal(market).then(function(res) {
            if (res) {
                return res;
            }
            return getModal(allMarkets);
        }).then(function(res) {
            setContent(res);
            setShowBuilderModal(!!res);
        });
        if (isSubscriptionModalActive && !isAffiliateEmail && !showBuilderModal && !getSubscriptionModalClosedCookie()) {
            setShowSubscriptionModal(true);
        }
    }, [
        getModal,
        market,
        showBuilderModal,
        subscriptionStatus,
        isSubscriptionModalActive,
        isAffiliateEmail, 
    ]);
    if (!showBuilderModal && !showSubscriptionModal) {
        return null;
    }
    if (showSubscriptionModal && subscriptionStatus === SubscriptionStatus_constants/* UNSUBSCRIBED */.$y) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            show: showSubscriptionModal,
            handleClose: handleCloseSubscriptionModal,
            maxWidth: "430px",
            displayHeader: false,
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "global.modal-home-subscription-header"
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionModal, {
                status: subscriptionStatus,
                onSubscribe: handleSubscribe
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        show: showBuilderModal,
        handleClose: function() {
            return setShowBuilderModal(false);
        },
        variant: constants/* VARIANT_MID_SCREEN */.lJ,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_react_es5/* BuilderComponent */.VD, {
            model: modalId,
            content: content,
            locale: locale
        })
    });
};
/* harmony default export */ var comps_BuilderModal = (BuilderModal);


/***/ }),

/***/ 26295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ WidgetPlaceholder; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12524);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_hooks_useMarket__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59806);
/* harmony import */ var src_hooks_usePage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73250);





function WidgetPlaceholder() {
    var pageId = (0,src_hooks_usePage__WEBPACK_IMPORTED_MODULE_4__/* .usePage */ .q)().pageId;
    var ref = (0,src_hooks_useMarket__WEBPACK_IMPORTED_MODULE_3__/* .useMarket */ .A)(), language = ref.language, market = ref.market;
    var classes = [
        "widget",
        "page-".concat(pageId),
        "lang-".concat(language),
        "mkt-".concat(market)
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        "data-testid": "widget-placeholder",
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(classes)
    });
}


/***/ }),

/***/ 93735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ REDIRECT_EXPERIMENT; },
/* harmony export */   "e": function() { return /* binding */ hasToNotifyRedirectExperiment; }
/* harmony export */ });
/* harmony import */ var _affiliates__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1620);

var REDIRECT_EXPERIMENT = {
    ID: "WEB-5452",
    REDIRECT_TO_SERP: 1,
    REDIRECT_TO_DETAILS: 0
};
var isKayakMultiOffer = function(query) {
    return query.aid === _affiliates__WEBPACK_IMPORTED_MODULE_0__/* .AFFILIATE_KAYAK */ .re && typeof query.offerType === "string" && [
        "multi_offer",
        "multi-offer"
    ].includes(query.offerType);
};
var isSkyScannerBestOffer = function(query) {
    return query.aid === _affiliates__WEBPACK_IMPORTED_MODULE_0__/* .AFFILIATE_SKYSCANNER */ .bO && typeof query.offerType === "string" && [
        "best_offer",
        "best-offer"
    ].includes(query.offerType);
};
var hasToNotifyRedirectExperiment = function(query) {
    return isKayakMultiOffer(query) || isSkyScannerBestOffer(query);
};


/***/ }),

/***/ 63325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useExperimentConfig; }
});

// UNUSED EXPORTS: useExperiment

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/context/experiment/index.tsx
var context_experiment = __webpack_require__(30115);
// EXTERNAL MODULE: ./src/hooks/useMarket.ts
var useMarket = __webpack_require__(59806);
// EXTERNAL MODULE: ./src/hooks/useSession.ts
var useSession = __webpack_require__(66334);
// EXTERNAL MODULE: ../../node_modules/murmurhash-js/index.js
var murmurhash_js = __webpack_require__(92346);
var murmurhash_js_default = /*#__PURE__*/__webpack_require__.n(murmurhash_js);
// EXTERNAL MODULE: ./client/contexts/Tracking/index.js
var Tracking = __webpack_require__(54168);
// EXTERNAL MODULE: ./client/contexts/Tracking/requests.js
var requests = __webpack_require__(47045);
// EXTERNAL MODULE: ./client/contexts/Tracking/utils.js + 1 modules
var utils = __webpack_require__(41639);
// EXTERNAL MODULE: ./src/context/experiment/constants.ts
var constants = __webpack_require__(5011);
// EXTERNAL MODULE: ./client/contexts/Tracking/constants.js
var Tracking_constants = __webpack_require__(61870);
// EXTERNAL MODULE: ./src/pages/_middleware/defaultAffiliate.ts
var defaultAffiliate = __webpack_require__(96004);
;// CONCATENATED MODULE: ./src/hooks/useExperimentConfig/helpers.ts







function validateExperiment(experiment, experimentKey) {
    if (!experiment) {
        return false;
    }
    if (experiment === constants/* MISSING_EXPERIMENT */.$) {
        return false;
    }
    if (experiment.key !== experimentKey) {
        return false;
    }
    return experiment;
}
function reportToKafka(kafkaEventPayload) {
    var _affiliate = kafkaEventPayload.affiliate, affiliate = _affiliate === void 0 ? defaultAffiliate/* DEFAULT_AFFILIATE_ID */._ : _affiliate, experiment = kafkaEventPayload.experiment, market = kafkaEventPayload.market, language = kafkaEventPayload.language, device = kafkaEventPayload.device, ip = kafkaEventPayload.ip, isBot = kafkaEventPayload.isBot, pageId = kafkaEventPayload.pageId, isLogged = kafkaEventPayload.isLogged, customer = kafkaEventPayload.customer;
    var eventName = "experiment";
    var eventType = "experiment";
    if (!experiment || experiment === constants/* MISSING_EXPERIMENT */.$) return;
    var timestamp = Date.now();
    var eventPayload = {
        hsl: murmurhash_js_default()("".concat(eventName).concat(timestamp).concat(eventType), 87) || null,
        level: "info",
        event_sub_type: null,
        ip: ip,
        is_bot: isBot,
        created_at: timestamp,
        screen: "".concat(window.screen.width, "x").concat(window.screen.height),
        session_id: (0,utils/* getSessionId */.MQ)(),
        language: language || null,
        source: "web",
        market: market,
        event_type: eventType || null,
        user_id: (customer === null || customer === void 0 ? void 0 : customer.userId) || null,
        scope: "tracking",
        event_name: eventName,
        device: device,
        user_agent: navigator.userAgent,
        payload: {
            affiliate: affiliate,
            page: pageId,
            experiments: [
                {
                    experiment_id: experiment.key,
                    experiment_variant: experiment.variant
                }
            ],
            is_logged: isLogged,
            origin: document.referrer || Tracking_constants/* ORIGIN_DIRECT */.Hz
        }
    };
    (0,requests/* trackingRequest */.c9)(eventPayload);
}
function reportToDataLayer(dataLayerEventPayload) {
    var experiment = dataLayerEventPayload.experiment;
    var payload = [];
    if (experiment && experiment !== constants/* MISSING_EXPERIMENT */.$) {
        payload.push({
            event: "sflExperiment",
            data: {
                expId: experiment.id,
                expVar: experiment.variant
            }
        });
    }
    (0,Tracking/* dataLayerPush */.l)(payload);
}
function reportExperiment(experimentPayload) {
    reportToDataLayer(experimentPayload);
    reportToKafka(experimentPayload);
}

// EXTERNAL MODULE: ./src/hooks/useDevice/index.ts
var useDevice = __webpack_require__(72731);
// EXTERNAL MODULE: ./src/hooks/usePage/index.ts
var usePage = __webpack_require__(73250);
// EXTERNAL MODULE: ./src/hooks/useBusiness.ts
var useBusiness = __webpack_require__(16153);
;// CONCATENATED MODULE: ./src/hooks/useExperimentConfig/index.ts








/**
 * ## useExperiment hook
 * @param experimentKey String key of the experiment. For example: 'WEB-0000'
 * @param validator Function to validate the experiment. If the function returns false, the experiment is not active
 * @returns
 *  - notify: Function to notify the experiment view. Receives the experiment key as parameter
 *  - variant: Number of the current variant. 0 if the experiment is not active (base)
 *
 * ### Usage
 * Notify the experiment view when the component is rendered
 * @example
 *  const { notify, variant } = useExperiment('WEB-0000');
 *  useEffectOnce(notify);
 *  if (variant === 1) {
 *    // Default behavior
 *  } else {
 *    // Variant behavior
 *  }
 *
 *  Notify the experiment view when a button is clicked
 *  @example
 *  const { notify, variant } = useExperiment('WEB-0000');
 *  useEffectOnce(notify);
 *  ...
 *  <Button onClick={notify}>Click me</Button>
 */ var useExperiment = function(experimentKey) {
    var validator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
        return true;
    };
    var pageId = (0,usePage/* usePage */.q)().pageId;
    var experiment = (0,react.useContext)(context_experiment/* ExperimentContext */.T);
    var ref = (0,useMarket/* useMarket */.A)(), market = ref.market, language = ref.language, currency = ref.currency;
    var ref1 = (0,useSession/* useSession */.k)(), isLogged = ref1.isLogged, customer = ref1.customer;
    var ref2 = (0,useDevice/* useDevice */.F)(), device = ref2.device, ip = ref2.ip, isBot = ref2.isBot;
    var affiliate = (0,useBusiness/* useBusiness */.i)().affiliate;
    var validatedExperiment = (0,react.useMemo)(function() {
        return validateExperiment(experiment, experimentKey);
    }, [
        experiment,
        experimentKey
    ]);
    var notify = (0,react.useCallback)(function() {
        if (!validatedExperiment || !validator(validatedExperiment.variant)) {
            return;
        }
        reportExperiment({
            affiliate: affiliate,
            experiment: experiment,
            market: market,
            language: language,
            isLogged: isLogged,
            customer: customer,
            device: device,
            ip: ip,
            isBot: isBot,
            pageId: pageId,
            currency: currency
        });
    }, [
        validatedExperiment,
        affiliate,
        experiment,
        market,
        language,
        isLogged,
        customer,
        device,
        ip,
        isBot,
        pageId,
        currency,
        validator, 
    ]);
    if (!validatedExperiment || !validator(validatedExperiment.variant)) {
        return {
            variant: 0,
            notify: function() {
                return undefined;
            }
        };
    }
    return {
        notify: notify,
        variant: validatedExperiment.variant
    };
};
/* harmony default export */ var useExperimentConfig = (useExperiment);


/***/ }),

/***/ 21671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ useRequireLogin; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50930);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50853);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _browser_eventBridge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51665);
/* harmony import */ var _s4l_react_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67048);
/* eslint-disable consistent-return */ /* eslint-disable @typescript-eslint/no-explicit-any */ 






function useRequireLogin(callback, source) {
    var domain = (0,_s4l_react_context__WEBPACK_IMPORTED_MODULE_2__/* .useS4LContext */ .ms)().domain;
    var innerCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(// eslint-disable-next-line consistent-return
    /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var _len, args, _key, ref, error, loginStatus, handleLoginChanged;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = _arguments[_key];
                    }
                    return [
                        4,
                        domain.GetCurrentLoginStatusAuthUseCase.execute()
                    ];
                case 1:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), error = ref[0], loginStatus = ref[1];
                    if (error) {
                        console.error(error);
                        return [
                            2
                        ];
                    }
                    if (loginStatus.isUnlogged()) {
                        (0,_browser_eventBridge__WEBPACK_IMPORTED_MODULE_1__/* .showLoginModal */ .m8)(source);
                        handleLoginChanged = function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                                var ref, loginError, newLoginStatus;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                domain.GetCurrentLoginStatusAuthUseCase.execute()
                                            ];
                                        case 1:
                                            ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"].apply */ .Z.apply(void 0, [
                                                _state.sent(),
                                                2
                                            ]), loginError = ref[0], newLoginStatus = ref[1];
                                            if (loginError) {
                                                console.error(loginError);
                                                return [
                                                    2
                                                ];
                                            }
                                            if (newLoginStatus.isLogged()) {
                                                callback(newLoginStatus).apply(this, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(args));
                                            }
                                            window.removeEventListener("login-change", handleLoginChanged);
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function handleLoginChanged() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        window.addEventListener("login-change", handleLoginChanged);
                        return [
                            2
                        ];
                    }
                    callback(loginStatus).apply(this, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(args));
                    return [
                        2
                    ];
            }
        });
    }), [
        callback,
        source,
        domain
    ]);
    return {
        callback: innerCallback
    };
}


/***/ }),

/***/ 67780:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"selectWrapper":"styles_selectWrapper__dalZg","option":"styles_option__Ylp4R","trigger":"styles_trigger__UV3FH","selected":"styles_selected__UwcyJ","triggerSelect":"styles_triggerSelect__EgeE4","active":"styles_active__2lYw8","triggerSort":"styles_triggerSort__ehi4y","list":"styles_list__4wBkv"};

/***/ }),

/***/ 34523:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subscriptionModalBase":"styles_subscriptionModalBase__VFEWE","subscriptionForm":"styles_subscriptionForm__QEJi8","subscriptionInput":"styles_subscriptionInput__JFRSQ","termsContainer":"styles_termsContainer__bv9Du","subscriptionModalTitle":"styles_subscriptionModalTitle__AskpV system_titleXs__EJJjY","subscriptionModalSubTitle":"styles_subscriptionModalSubTitle__d9yp1 system_textBodyM__ZzPjG","successContainer":"styles_successContainer__dIEHT"};

/***/ })

}]);